import { SVGProps } from './SVGProps';

const Calendar = ({ fill = '#D9D9D9', width = '18', height = '18' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 30 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.495117 11.242V5.07715H29.5061V11.242H0.495117Z" fill="black" stroke="black" strokeWidth="0.725275" />
      <path
        d="M29.5061 11.6045H0.495117V31.5495C0.495117 32.71 1.46215 33.0001 1.94567 33.0001H28.0556C29.216 33.0001 29.5061 32.0331 29.5061 31.5495V11.6045Z"
        stroke="black"
        strokeWidth="0.725275"
      />
      <path
        d="M8.47327 0.362671H7.748C6.74661 0.362671 5.93481 1.17446 5.93481 2.17586V7.97805C5.93481 8.97945 6.74661 9.79124 7.748 9.79124H8.47327C9.47467 9.79124 10.2865 8.97945 10.2865 7.97805V2.17586C10.2865 1.17446 9.47467 0.362671 8.47327 0.362671Z"
        fill="#D9D9D9"
        stroke="black"
        strokeWidth="0.725275"
      />
      <path
        d="M22.2535 0.362671H21.5283C20.5269 0.362671 19.7151 1.17446 19.7151 2.17586V7.97805C19.7151 8.97945 20.5269 9.79124 21.5283 9.79124H22.2535C23.2549 9.79124 24.0667 8.97945 24.0667 7.97805V2.17586C24.0667 1.17446 23.2549 0.362671 22.2535 0.362671Z"
        fill="#D9D9D9"
        stroke="black"
        strokeWidth="0.725275"
      />
      <path
        d="M12.25 25.85L8.40003 22L7.1167 23.2833L12.25 28.4166L23.25 17.4166L21.9667 16.1333L12.25 25.85Z"
        fill="black"
      />
    </svg>
  );
};

export default Calendar;
